import React from 'react'
import { Link } from 'react-router-dom'
import { Breadcrumb } from 'antd'
import { get, map } from 'lodash'
import PropTypes from 'prop-types'

import { APP_ROUTES } from '../../constants'

const NodeBreadcrumbs = ({ metadataType, namePath, idPath }) => (
  <Breadcrumb>
    <Breadcrumb.Item>
      <Link to={get(APP_ROUTES, `${metadataType.value}.link`)} target="_blank">
        {metadataType.label}
      </Link>
    </Breadcrumb.Item>
    {map(namePath, (name, index) => (
      <Breadcrumb.Item key={idPath[index]}>
        <Link
          to={`${get(APP_ROUTES, `${metadataType.value}.link`)}/${
            idPath[index]
          }`}
          target="_blank"
        >
          {name}
        </Link>
      </Breadcrumb.Item>
    ))}
  </Breadcrumb>
)

NodeBreadcrumbs.propTypes = {
  metadataType: PropTypes.object.isRequired,
  idPath: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ).isRequired,
  namePath: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default NodeBreadcrumbs
